import { Component, TemplateRef, OnInit, AfterViewInit, AfterViewChecked, AfterContentInit } from '@angular/core';
import { TokenService } from '../authentication/token.service';
import { Router } from '@angular/router';

import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

import { LocalUserService } from '../authentication/local-user.service';

import * as decode from 'jwt-decode';

const ADMIN_PERM_LEVEL = 3;
const COMPTA_PERM_LEVEL = 2;
const DEFAULT_PERM_LEVEL = 0;

declare var $:any;
//Metadata
export interface RouteInfo {
    path: string;
    title: string;
    id: string;
    type: string;
    icontype: string;
    auth?: number;
    // icon: string;
    children?: ChildrenItems[];
}

export interface ChildrenItems {
    path: string;
    title: string;
    ab: string;
    type?: string;
    auth?: number;
}

//Menu Items
/**
 * - Tableau de bord
 * - compte
 *      - courtier
 *      - association
 *      - Groupement Individuels
 *      - Souscripteurs
 *      - Salariés
 * - Mouvements
 *      - Versements
 *      - Placements
 *      - Rachats
 * - Opérations
 *      - Positionnement
 *      - Valorisation
 *      - Frais de Gestion
 * - Commissions
 *      - Commissions Courtier
 *      - Honoraires
 * - Configurations
 *      - Taxes
 *      - Frais
 */
export const ROUTES: RouteInfo[] = [
    {
        path: '/tableaudebord',
        title: 'Tableau de bord',
        id: 'tableaudebord',
        type: 'link',
        icontype: 'ti-panel',
        auth: ADMIN_PERM_LEVEL
        // children: [
        //     {path: 'overview', title: 'Aperçu', ab:'O'},
        //     {path: 'stats', title: 'Statistiques', ab:'S'}
        // ]
    },{
        path: '/compte',
        title: 'compte',
        id: 'compte',
        type: 'sub',
        icontype: 'ti-package',
        auth: ADMIN_PERM_LEVEL,
        children: [
            {path: 'courtier', title: 'Courtiers', ab:'C'},
            {path: 'institution', title: 'Institutions financières', ab:'IF'},
            {path: 'association', title: 'Associations', ab:'A'},
            {path: 'groupement', title: 'Groupement Individuels', ab:'GI'},
            {path: 'souscripteur', title: 'Souscripteurs', ab:'SO'},
            {path: 'salarie', title: 'Salariés', ab:'S'},
            {path: 'rente', title: 'Rentes', ab:'R'}
        ]
    },{
        path: '/mouvement',
        title: 'Mouvements',
        id: 'mouvement',
        type: 'sub',
        icontype: 'ti-clipboard',
        children: [
            {path: 'versement', title: 'Versements', ab:'V', auth: ADMIN_PERM_LEVEL},
            {path: 'placement', title: 'Placements', ab:'P', auth: COMPTA_PERM_LEVEL},
            {path: 'rachat', title: 'Rachats', ab:'R', auth: ADMIN_PERM_LEVEL},
            {path: 'transfert', title: 'Transferts', ab:'T', auth: ADMIN_PERM_LEVEL}
        ]
    },{
        path: '/operation',
        title: 'Operations',
        id: 'operation',
        type: 'sub',
        icontype: 'ti-view-list-alt',
        auth: ADMIN_PERM_LEVEL,
        children: [
            {path: 'positionnement', title: 'Positionnements', ab:'P'},
            {path: 'valorisation', title: 'Valorisations', ab:'V'},
            {path: 'fraisgestion', title: 'Frais de Gestion', ab:'FG'}
        ]
    },{
        path: '/commission',
        title: 'Commissions',
        id: 'commission',
        type: 'sub',
        icontype: 'ti-map',
        auth: ADMIN_PERM_LEVEL,
        children: [
            {path: 'commissioncourtier', title: 'Commissions Courtier', ab:'C'},
            {path: 'honoraire', title: 'Honoraires', ab:'H'}
        ]
    },{
        path: '/configuration',
        title: 'Configurations',
        id: 'configuration',
        type: 'sub',
        icontype: 'ti-gift',
        auth: ADMIN_PERM_LEVEL,
        children: [
            {path: 'taxes', title: 'Taxes', ab:'T'},
            {path: 'frais', title: 'Frais', ab:'F'},
            {path: 'sauvegarde', title: 'Sauvegarde', ab:'S'}
        ]

    },{
        path: '/simulation',
        title: 'Simulations',
        id: 'simulation',
        type: 'link',
        icontype: 'ti-panel',
        auth: ADMIN_PERM_LEVEL,
    }
];

@Component({
    moduleId: module.id,
    selector: 'sidebar-cmp',
    templateUrl: 'sidebar.component.html',
})

export class SidebarComponent {

    public menuItems: any[];

    public search_term: string = "";

    public modalRef: BsModalRef;
    public password_validation: string;

    constructor(private router: Router,
        private token: TokenService,
        private modalService: BsModalService,
        public localUser: LocalUserService ) {};

    isNotMobileMenu(){

        if($(window).width() > 991){
            return false;
        }
        return true;
    }

    ngOnInit() {

        const token = localStorage.getItem('token');
        const tokenPayload = decode(token);

        var isWindows = navigator.platform.indexOf('Win') > -1 ? true : false;
        // this.menuItems = ROUTES.filter(menuItem => menuItem);
        // filter menus
        this.menuItems = ROUTES
        .map(menuItem => {

            if(menuItem.children){
                menuItem.children = menuItem.children.filter(subMenuItem => subMenuItem.auth ? subMenuItem.auth <= tokenPayload.authorization_level : true)
            }

            return menuItem;
        })
        .filter(menuItem => {

            return menuItem.auth ? menuItem.auth <= tokenPayload.authorization_level : true;
        });

        isWindows = navigator.platform.indexOf('Win') > -1 ? true : false;

        if (isWindows){

           // if we are on windows OS we activate the perfectScrollbar function
           $('.sidebar .sidebar-wrapper, .main-panel').perfectScrollbar();
           $('html').addClass('perfect-scrollbar-on');
        }
        else
           $('html').addClass('perfect-scrollbar-off');

        this.localUser.getSignedInUser();
    }

    ngAfterViewInit(){

        var $sidebarParent = $('.sidebar .nav > li.active .collapse li.active > a').parent().parent().parent();
        var collapseId = $sidebarParent.siblings('a').attr("href");
        $(collapseId).collapse("show");
    }

    gotToSearch(valid: boolean){

        if(valid){

            this.router.navigate(['compte', 'recherche', this.search_term]);
        }
    }

    logOut() {

      this.token.logOut();
      this.router.navigate(['pages', 'login']);
    }

    openProfileEditor(template: TemplateRef < any > ) {

        this.modalRef = this.modalService.show(template);
    }

    updateProfile(valid, passconfirm) {

        if(valid) {

            this.localUser.updateProfile();
            this.modalRef.hide();
            this.password_validation="";
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/sidebar/sidebar.component.ts